package com.eladfinish.bible.contest.screens.pairMatching.ui

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.extensions.makeBoldByAsterisksAnnotated
import com.eladfinish.bible.contest.screens.pairMatching.model.ValueItem
import com.eladfinish.bible.contest.ui.common.PreviewTheme

// ── Colors ────────────────────────────────────────────────────────────────────
private val colorYellow = Color(0xFFFFEB3B) // YELLOW — normal draggable state
private val colorDragging = Color(0xFFFFD54F) // slightly darker while dragging

@Composable
fun PairMatchingValueItemView(
    item: ValueItem,
    isDragging: Boolean,
    modifier: Modifier = Modifier,
) {
    if (!item.isVisible) return

    Box(
        modifier = modifier.fillMaxWidth(0.85f),
        contentAlignment = Alignment.Center,
    ) {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .heightIn(min = 48.dp)
                .padding(vertical = 6.dp),
            shape = RoundedCornerShape(8.dp),
            colors = CardDefaults.cardColors(
                containerColor = if (isDragging) colorDragging else colorYellow,
            ),
            elevation = CardDefaults.cardElevation(
                defaultElevation = if (isDragging) 8.dp else 2.dp,
            ),
        ) {
            Text(
                text = item.rawText.makeBoldByAsterisksAnnotated(),
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(8.dp),
                textAlign = TextAlign.Center,
                fontSize = 18.sp,
                color = Color.Black,
            )
        }
    }
}

// ─── Previews ─────────────────────────────────────────────────────────────────

@Preview(showBackground = true, name = "ValueItem — normal")
@Composable
private fun ValueItemNormalPreview() {
    PreviewTheme {
        PairMatchingValueItemView(
            item = ValueItem(id = 10, rawText = "חברון"),
            isDragging = false,
        )
    }
}

@Preview(showBackground = true, name = "ValueItem — dragging")
@Composable
private fun ValueItemDraggingPreview() {
    PreviewTheme {
        PairMatchingValueItemView(
            item = ValueItem(id = 10, rawText = "חברון"),
            isDragging = true,
        )
    }
}

@Preview(showBackground = true, name = "ValueItem — with bold asterisks")
@Composable
private fun ValueItemBoldPreview() {
    PreviewTheme {
        PairMatchingValueItemView(
            item = ValueItem(id = 10, rawText = "*חברון* הישנה"),
            isDragging = false,
        )
    }
}
